
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';

import {
    dataAnalysisEmployeeOperatorOperationLogList
} from '@/api/toBApi';

@Component({
    name: '',
    components: {
        PageFooter,
        PickerDate
    }
})
export default class OperationLog extends Vue {

    private list = [];
    private keywords = '';
    private behave = null;
    private pageNo = 1;
    private pageSize = 20;
    private total = 0;
    private loading = false;

    private behaveList = [
        { value: null, label: '全部' },
        { value: 1, label: '登录APP' },
        { value: 2, label: '切换团队' },
        { value: 3, label: '访问页面' }
    ];



    private mounted() {
        this.doSearch();
    }

    private doSearch() {
        this.pageNo = 1
        this.getList()
    }
    private changePage(e) {
        this.pageNo = e
        this.getList()
    }
    private async getList() {
        this.loading = true;
        try {
            let params = {
                Keywords: this.keywords.trim(),
                OperationBehaviorType: this.behave,
                Skip: (this.pageNo - 1) * this.pageSize,
                Take: this.pageSize
            }
            const res: any = await dataAnalysisEmployeeOperatorOperationLogList(params);
            this.list = res.Result.Results;
            this.total = res.Result.Total;

        } catch (error) {

        } finally {
            this.loading = false;
        }
    }

}
